/**
 * Analytics helpers for Google Ads / gtag.
 *
 * `phone_click` and `whatsapp_click` events fire on every relevant CTA and
 * are always sent (great for GA4 audience building).
 *
 * A Google Ads *conversion* is additionally reported when
 * REACT_APP_ADS_PHONE_CONVERSION (or REACT_APP_ADS_LEAD_CONVERSION) is
 * set to the full `AW-XXXXXXXXXX/AbCdEfGhIj` send_to string.
 */

const PHONE_CONVERSION = process.env.REACT_APP_ADS_PHONE_CONVERSION || "";
const LEAD_CONVERSION = process.env.REACT_APP_ADS_LEAD_CONVERSION || "";

const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

export const trackPhoneClick = (source) => {
  gtag("event", "phone_click", {
    event_category: "engagement",
    event_label: source,
    source,
  });
  if (PHONE_CONVERSION) {
    gtag("event", "conversion", {
      send_to: PHONE_CONVERSION,
      value: 1,
      currency: "INR",
      event_label: source,
    });
  }
};

export const trackWhatsAppClick = (source) => {
  gtag("event", "whatsapp_click", {
    event_category: "engagement",
    event_label: source,
    source,
  });
};

export const trackLeadSubmit = (issueType) => {
  gtag("event", "generate_lead", {
    event_category: "lead",
    event_label: issueType || "unknown",
    issue_type: issueType,
  });
  if (LEAD_CONVERSION) {
    gtag("event", "conversion", {
      send_to: LEAD_CONVERSION,
      value: 1,
      currency: "INR",
      event_label: issueType,
    });
  }
};
